import pages from '@/config/i18n.pages'

export const setList = routeName => {
  const baseUrl = process.env.BASE_URL
  const alternate = []

  const page = routeName.split('___')[0]

  const defaultUrl = pages[`${page}`]['en'] ? `en${pages[`${page}`]['en']}` : `pt-br${pages[`${page}`]['pt-br']}`
  const alternateDefault = {
    hid: 'alt-default',
    rel: 'alternate',
    href: `${baseUrl}/${defaultUrl}`,
    hreflang: 'x-default',
  }

  const pagesVariants = Object.keys(pages[`${page}`])

  pagesVariants.map(variant => {
    if (variant) {
      const hreflang = variant.length > 2 ? `${variant.split('-')[0]}-${variant.split('-')[1]?.toUpperCase()}` : variant

      if (!pages[page][variant]) {
        return
      }

      const alternateObj = {
        hid: `alt-${variant}`,
        rel: 'alternate',
        href: `${baseUrl}/${variant}${pages[page][variant]}`,
        hreflang,
      }

      alternate.push(alternateObj)
    }

    return true
  })

  alternate.push(alternateDefault)

  if (alternate.length <= 2) return []

  return alternate
}

export default {
  setList,
}
